var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKightsFeatureReplaceModalIcon = function SvgKightsFeatureReplaceModalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.5,
    height: 38.5,
    rx: 3.208,
    fill: "#F0B51A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kights_feature_replace_modal_icon_svg__a)",
    stroke: "#fff",
    strokeWidth: 1.515,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.597 7.486 4.278 4.278-4.278 4.278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.625 18.18v-2.138a4.278 4.278 0 0 1 4.278-4.278h14.972M13.903 31.014l-4.278-4.278 4.278-4.278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.875 20.32v2.139a4.278 4.278 0 0 1-4.278 4.277H9.625"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kights_feature_replace_modal_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(6.417 6.417)",
    d: "M0 0h25.667v25.667H0z"
  })))));
};
export default SvgKightsFeatureReplaceModalIcon;